import {
  createEffect,
  createEvent,
  createStore,
  restore,
  sample,
} from 'effector'
import { persist } from 'effector-storage/session'
import { model as router } from '~/core/router'
import { appearanceFeature } from '~/features/appearance'
import { noop } from '~/shared/effector'
import { actualIdentifier } from './lib'

export const selectModule = createEvent<string | { identifier: string }>()
const getActualIdentifierFx = createEffect(actualIdentifier)

// navbar selected module identifier
const $selectedModule = createStore<string | null>(null) //
  .on(selectModule, (_, id) => (typeof id === 'string' ? id : id.identifier))

// navbar selected module identifier with actual url awareness
export const $actualSelectedModule = restore(getActualIdentifierFx, '')

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  store: $selectedModule,
  key: 'tria__navbar-module',
  fail: noop,
})

// update actual identifier when selected module changes
sample({
  clock: [$selectedModule, router.$location],
  source: { selected: $selectedModule, modules: appearanceFeature.$modules },
  target: getActualIdentifierFx,
})

// reselect module when actual identifier changes (e.g. url changed)
sample({
  clock: $actualSelectedModule,
  target: selectModule,
})
